import { WorksheetField } from '../common/components/Field';
import { ProductionUnit } from '~/constants';
import { ProjectArrayDropdownOptions } from '~/constants';
import { useProjectContext } from '~/hooks';

export default function PricingEstimateArray() {
  const { project, updateProjectValue } = useProjectContext();

  const addFirstArray = () => {
    const projectArrays = project.projectArrays ?? [];
    updateProjectValue('projectArrays', [...projectArrays, { projectId: project.id, order: 0, yearOneProductionUnit: ProductionUnit.KWHKW }]);
  };

  const hasArrays = project.projectArrays && project.projectArrays.length > 0;

  // This is a workaround to make sure that the default unit for yearOneProduction is always set
  // For some reason adding the yearOneSavingUnit broke this default setting
  if (hasArrays && !project.projectArrays?.[0]?.yearOneProductionUnit) {
    updateProjectValue('projectArrays.0.yearOneProductionUnit', ProductionUnit.KWHKW);
  }

  if (!hasArrays) {
    return (
      <div style={{ textAlign: 'center', padding: '1rem', border: '2px dashed #ddd', borderRadius: '4px', margin: '1rem 0' }}>
        <p style={{ margin: '0 0 0.5rem 0', color: '#666' }}>Add an array to get started</p>
        <button 
          type="button"
          onClick={addFirstArray}
          style={{
            background: 'var(--color-primary)',
            color: 'white',
            border: 'none',
            padding: '0.5rem 1rem',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Add Array
        </button>
      </div>
    );
  }

  return (
    <>
      <WorksheetField
        type='dropdown'
        schemaKey={'projectArrays.0.type'}
        fieldLabel='Array type'
        placeholder="Select an array type"
        options={ProjectArrayDropdownOptions}
      />
      <WorksheetField.Row isQuote>
        <div className="labelled-input">
          <WorksheetField
            type='number'
            schemaKey={'projectArrays.0.sizeKwdc'}
            fieldLabel='Size in kWdc'
            placeholder='Enter value'
            label='kWdc'
          />
        </div>
        <div className='radio-selections'>
          <WorksheetField
            type="number"
            schemaKey={'projectArrays.0.yearOneProduction'}
            fieldLabel="Year one production"
            decimals={0}
            unitField="yearOneProductionUnit"
            placeholder="Enter production"
            units={[
              { value: ProductionUnit.KWH, label: 'kWh' },
              { value: ProductionUnit.KWHKW, label: 'kWh/kW' },
            ]}
            defaultUnit={ProductionUnit.KWHKW}
          />
        </div>
      </WorksheetField.Row>
    </>
  );
};  